import { useEffect } from "react";
import { useSnapshot } from "valtio";
import { configStore, loginStore } from "../state/CommonState";
import { enquiryStore } from "./enquiry-data";
import HomeMain from "./home-main";

export default function EnquiryHome(params) {
  useSnapshot(enquiryStore);
  useSnapshot(configStore);
  useSnapshot(loginStore);

  useEffect(() => {
    enquiryStore.initialize();
    enquiryStore.currentCargoTableKey = "" + new Date().getMilliseconds();
    enquiryStore.current.createdBy = loginStore.email;
    enquiryStore.current.entityId = configStore.currentSelectedEntity.entityId;
    enquiryStore.current.shipmentType =
      configStore.homescreenCurrentShipmentType;
    configStore.homescreenCurrentView = "new";
    configStore.scheduleOrCarrierform = "schedule";
  }, []);
  return <HomeMain />;
}
